export const isValidName = (text) => /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]*$/.test(text);
export const isValidUsername = (text) => /^[A-Za-z0-9]*$/.test(text);
export const isEmailValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
export const isPasswordValid = (password) => password.length >= 7;
export const isDescriptionValid = (text) => /^[A-Za-z0-9áéíóúÁÉÍÓÚñÑ,.\-_\s]*$/.test(text);